
const Chevron = () => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.5 12.5">
		<g transform="translate(13, 3) rotate(90)">
			<path className="stroke" d="M15.382,21.229a.38.38,0,0,0,.54,0L21.646,15.5a.382.382,0,0,0,0-.54L15.921,9.241a.382.382,0,1,0-.54.54l5.454,5.455-5.454,5.453a.382.382,0,0,0,0,.54Z" transform="translate(-15.27 -9.129)" />
		</g>
	</svg>
)

export default Chevron;